import { useNavigate } from 'react-router-dom';
import ResidentSettingsNavigationQueryParameters from 'shared/constants/resident-settings-navigation-query-parameters';
import Routes from 'shared/enums/routes';
import OrganisationTreeNode from 'shared/features/organisation/models/organisation-tree-node';

type ResidentSettingsNavigation = {
  navigateToResidentSettings: (organisationUnit: OrganisationTreeNode) => void;
};

const useResidentSettingsNavigation = (): ResidentSettingsNavigation => {
  const navigate = useNavigate();

  const navigateToResidentSettings = (organisationUnit: OrganisationTreeNode): void => {
    if (!organisationUnit.parentId) {
      return;
    }

    const searchParameters = new URLSearchParams({
      [ResidentSettingsNavigationQueryParameters.ResidentOrganisationUnitId]: organisationUnit.id,
      [ResidentSettingsNavigationQueryParameters.ParentOrganisationUnitId]: organisationUnit.parentId,
      [ResidentSettingsNavigationQueryParameters.SearchTerm]: organisationUnit.name,
    });

    navigate(`${Routes.Residents}/${Routes.ResidentsSettings}?${searchParameters.toString()}`);
  };

  return { navigateToResidentSettings };
};

export default useResidentSettingsNavigation;
